import { jsx as _jsx } from "react/jsx-runtime";
import { WithUser } from "common-frontend-components";
import { Grid } from "@mui/material";
import { pageStyle } from "../../assets/styles/styles";
import { ProductManager } from "../../components/entities/products/product/ProductManager";
import { useOnLazyPageLoad } from "../../hooks/useOnAppLoad";
export const AdminProductsManagementPage = WithUser(() => {
    useOnLazyPageLoad();
    return (_jsx(Grid, { container: true, spacing: 2, sx: pageStyle, children: _jsx(Grid, { item: true, xs: 12, children: _jsx(ProductManager, {}, void 0) }, void 0) }, void 0));
});
//# sourceMappingURL=AdminProductsManagementPage.js.map